import type { VoxelRasterDimensions } from '@/modules/Editor/models/raster/VoxelRaster'
import { getPrimaryViewFromView } from '@/modules/Editor/plugins/mask/utils/shared/getPrimaryViewFromView'
import type { View } from '@/modules/Editor/views/view'
import { primaryPlaneToRasterPlaneData } from '@/modules/Editor/utils/raster/primaryPlaneToRasterPlaneData'
import { getRasterPlaneFromRadiologySlotName } from '@/modules/Editor/utils/raster/getRasterPlaneFromRadiologySlotName'

export const getVoxelRasterDimensions = (view: View): VoxelRasterDimensions | undefined => {
  const primaryView = getPrimaryViewFromView(view)
  if (!primaryView) {
    return
  }

  const { metadata } = primaryView.fileManager.file
  if (metadata === undefined) {
    return
  }

  const currentPlaneName = getRasterPlaneFromRadiologySlotName(
    view.fileManager.file.slot_name,
    metadata,
  )
  if (currentPlaneName === undefined) {
    return
  }

  const acquiredPlaneWidth = metadata.pixelWidth ?? metadata.width
  const acquiredPlaneHeight = metadata.pixelHeight ?? metadata.height
  const acquiredPlaneDepth = primaryView.totalFrames

  const rasterDimensions = primaryPlaneToRasterPlaneData(
    metadata?.primary_plane,
    currentPlaneName,
    acquiredPlaneWidth,
    acquiredPlaneHeight,
    acquiredPlaneDepth,
  )

  return rasterDimensions
}
